import React, { useEffect, useMemo, useRef, useState } from "react";
import i18n from "i18next";

import useWindowSize from "../helpers/useWindowSize";
import { IStuelipos } from "../Models/IStuelipos";
import { baseUrl } from "../helpers/constants";
import { fetchWrapper } from "../helpers/fetchwrapper";
import { IStueli } from "../Models/IStueli";
import { Button } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

interface IDocumentPdfViewer01Props {
  onDismiss: any;
  title: string;
  path: string;
  stueliId?: string | undefined;
  addToBedarf?: any;
  // canDownload: boolean;
}

function DocumentPdfViewer01(props: IDocumentPdfViewer01Props) {
  const [stueli, setStueli] = useState<IStueli | undefined>(undefined);

  const getStueli = (artikelId: string) => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/bom/getbom?artikelId=${artikelId}`)
      .then((data: IStueli) => {
        data.positionen = data.positionen.filter(
          (pos: IStuelipos) => pos.stueliId == artikelId,
        );
        setStueli(data);
      });
  };

  useEffect(() => {
    if (props.stueliId && props.stueliId != "") {
      getStueli(props.stueliId);
    } else {
      setStueli(undefined);
    }
  }, [props.stueliId]);

  useEffect(() => {
    if (props.path == "") {
    } else {
      if (
        props.path.toLowerCase().endsWith(".stl") ||
        props.path.toLowerCase().endsWith(".mp4")
      ) {
      }
    }
  }, [props.path]);

  const size = useWindowSize();

  let useVideoMaxHeight = false;
  const videoMaxWidth = size.width - 110;
  const videoMaxHeight = size.height - 130;

  if ((videoMaxWidth / 16) * 9 > videoMaxHeight) {
    // videoMaxHeight verwenden
    useVideoMaxHeight = true;
  }

  return (
    <div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: "relative",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <div style={{ height: "26px" }}>
            <Button
              size="large"
              appearance="transparent"
              icon={<DismissRegular fontSize={60} />}
              onClick={() => {
                props.onDismiss();
              }}
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
              }}
            />
          </div>

          <video
            src={props.path}
            controls
            style={{
              width: useVideoMaxHeight ? undefined : videoMaxWidth - 70,
              height: useVideoMaxHeight ? videoMaxHeight - 70 : undefined,
              borderRadius: "8px",
              display: "block",
              margin: "0 auto",
            }}
            controlsList="nodownload"
            autoPlay
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentPdfViewer01;
